import styled from 'styled-components';
import { Form } from '@/components';

export const StyledForm = styled(Form)`
  display: flex;
  gap: 1rem;

  button {
    margin-top: 2rem;
  }
`;
